import * as React from 'react';
import { ClickTracker } from 'bernie-analytics';
import { UitkCardLink } from 'uitk-react-cards';
import { Link } from 'react-router-dom';

import { onClickScrollToTarget } from 'utils/smooth-scroll';

function handleClick() {
  onClickScrollToTarget({ scrollTo: 0 });
}

const LinkTracked = ClickTracker(Link);

export interface DestinationRefinementLinkProps {
  id: string;
  position: number;
  searchUrl: string;
  name: string;
}

export const DestinationRefinementLink: React.FunctionComponent<DestinationRefinementLinkProps> = ({ searchUrl, position, id, name }) => (
  <UitkCardLink>
    <LinkTracked
      linkName="Click Refined Destination"
      onClick={handleClick}
      rfrr={`.DestinationRefinement.Click${position}.Destination${id}`}
      to={searchUrl}
    >
      {name}
    </LinkTracked>
  </UitkCardLink>
);
